import clsx from 'clsx'

import styles from './Notification.module.scss'
import { INotification } from '../types'
import CheckIcon from '../assets/check.svg'
import { ErrorNotification } from './ErrorNotification'

interface Props extends Partial<INotification> {
    clearNotification?: () => void
}

export const Notification = ({
    title,
    message,
    className,
    type = 'default',
    size,
    clearNotification,
    errorDismissTitle,
    icon,
}: Props) => {
    const isSubmitNotification = type === 'submit'

    if (type === 'error' && clearNotification) {
        return (
            <ErrorNotification
                clearNotification={clearNotification}
                title={title}
                message={message}
                className={className}
                size={size}
                errorDismissTitle={errorDismissTitle}
            />
        )
    }

    return (
        <div className={clsx(styles.root, size && styles[size], styles[type], className)}>
            {isSubmitNotification && (
                <span className={styles.submitIcon}>
                    {icon ?? <CheckIcon />}
                </span>
            )}
            <div className={clsx({ [styles.submitText]: isSubmitNotification })}>{message}</div>
        </div>
    )
}
